import React from 'react';
import {useAsyncError } from 'react-router-dom';

function ErrorMessage(){
    const error = useAsyncError();

    return <p>{`error: ${error}`}</p>
}

export default ErrorMessage;